import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import event from '~helpers/mixpanel';
import PAYMENTPLAN_HELP_ONE from '~css/imgs/payment-plan-deposit-one.png';
import PAYMENTPLAN_HELP_TWO from '~css/imgs/payment-plan-deposit-two-one.png';
import PAYMENTPLAN_HELP_TWO_TWO from '~css/imgs/payment-plan-deposit-two-two.png';
import PAYMENTPLAN_HELP_THREE from '~css/imgs/payment-plan-deposit-three.png';
import PAYMENTPLAN_HELP_FOUR from '~css/imgs/payment-plan-deposit-four.png';
import { getSafeHtml } from 'common/helpers/safeHtml';
import { pageType } from '~constants/pages';

const PaymentPlanHelp = () => {
  const { t } = useTranslation();
  useEffect(() => {
    event('Viewed News in Help Center Page', {
      'Function Name': 'Payment Plan - Deposit Only',
      'Current Page Type': pageType.helpCenterPage,
    });
  }, []);
  return (
    <div className="paymentplan-help">
      <div className="paymentplan-help__box">
        <div>
          <div className="common__title">{t('landlord.new_dashboard.payment-plan-help.title')}</div>
          <div className="paymentplan-help__desc">
            <span>{getSafeHtml(t('landlord.new_dashboard.payment-plan-help.desc'))}</span>
          </div>
        </div>
        <div className="paymentplan-help__step">
          {t('landlord.new_dashboard.help.step', { count: 1 })}
        </div>
        <div className="paymentplan-help__first">
          <div className="common__imgbox">
            <img
              src={PAYMENTPLAN_HELP_ONE}
              alt={t('landlord.new_dashboard.payment-plan-help.title')}
            />
          </div>
        </div>
        <div className="paymentplan-help__step">
          {t('landlord.new_dashboard.help.step', { count: 2 })}
        </div>
        <div className="paymentplan-help__second">
          <div className="common__imgbox">
            <img
              src={PAYMENTPLAN_HELP_TWO}
              alt={t('landlord.new_dashboard.payment-plan-help.title')}
            />
          </div>
        </div>
        <div className="paymentplan-help__first">
          <div className="common__imgbox">
            <img
              src={PAYMENTPLAN_HELP_TWO_TWO}
              alt={t('landlord.new_dashboard.payment-plan-help.title')}
            />
          </div>
        </div>

        <div className="paymentplan-help__step">
          {t('landlord.new_dashboard.help.step', { count: 3 })}
        </div>
        <div className="paymentplan-help__first">
          <div className="common__imgbox">
            <img
              src={PAYMENTPLAN_HELP_THREE}
              alt={t('landlord.new_dashboard.payment-plan-help.title')}
            />
          </div>
        </div>

        <div className="paymentplan-help__step">
          {t('landlord.new_dashboard.help.step', { count: 4 })}
        </div>
        <div className="common__imgbox">
          <img
            src={PAYMENTPLAN_HELP_FOUR}
            alt={t('landlord.new_dashboard.payment-plan-help.title')}
          />
        </div>
      </div>
    </div>
  );
};
export default PaymentPlanHelp;
